var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CategoryAsideBlock",
    {
      staticClass: "sort-mobile",
      attrs: { title: _vm.i18n("Sort by"), tabindex: "-1" }
    },
    [
      _vm._l(_vm.selectOptions, function(ref) {
        var key = ref.key
        var name = ref.name
        var direction = ref.direction
        return [
          _c(
            "UIInputRadio",
            {
              key: key + "-" + direction,
              attrs: {
                id: key + "-" + direction,
                value: [key, direction],
                checked: _vm.isActive(key, direction),
                "wrapper-class": [
                  "sort-mobile__control",
                  { "is-active": _vm.isActive(key, direction) }
                ],
                name: "sort",
                tabindex: "0"
              },
              nativeOn: {
                input: function($event) {
                  return _vm.setOrder(key, direction)
                }
              }
            },
            [
              name === "Price" ? [_vm._v("Cena")] : [_vm._v(_vm._s(name))],
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.i18n(
                        direction === "desc" ? "descending" : "ascending"
                      )
                    ) +
                    "\n            "
                )
              ])
            ],
            2
          )
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }